// Globals
import { useTranslation } from 'react-i18next';

// Models
import { ISettlementData } from '@/models/prices.model';

// Components
import { EditIcon } from '@/icons';
import { Button } from '@/ui';
import {
  StyledButtonsWrapper,
  StyledCard,
  StyledContentWrap,
  StyledItem,
  StyledLabel,
  StyledName,
  StyledTitleWrapper,
  StyledValue,
  StyledWrapper,
} from './SettlementCardStyles';

type TSettlementCardProps = {
  data: ISettlementData | null;
  onEdit: () => void;
};

const SettlementCard = ({ data, onEdit }: TSettlementCardProps) => {
  const { t } = useTranslation('prices');
  return (
    <StyledCard>
      <StyledWrapper>
        <StyledTitleWrapper>
          <StyledName>{data?.name_no}</StyledName>
          <StyledLabel>({data?.name_en})</StyledLabel>
        </StyledTitleWrapper>
        <StyledButtonsWrapper>
          <Button ghost type="dashed" icon={<EditIcon />} onClick={onEdit} />
        </StyledButtonsWrapper>
      </StyledWrapper>
      <StyledContentWrap>
        <StyledItem>
          <StyledLabel>{t('label_description_en')}</StyledLabel>
          <StyledValue>
            <div dangerouslySetInnerHTML={{ __html: data?.description_en ?? '-' }} />
          </StyledValue>
        </StyledItem>

        <StyledItem>
          <StyledLabel>{t('label_description_no')}</StyledLabel>
          <StyledValue>
            <div dangerouslySetInnerHTML={{ __html: data?.description_no ?? '-' }} />
          </StyledValue>
        </StyledItem>
      </StyledContentWrap>
    </StyledCard>
  );
};

export default SettlementCard;
